import React from 'react';
import { useContext } from 'react';
import { AppConfigContext } from '../../Config/App';
import Iframe from 'react-iframe';
import Ads from '../../Components/ads';

const Donate = ({classes}) => {
    const { assets_url } = useContext(AppConfigContext);

    return (
        <div className={classes}>

            <div className='container text-center mb-3'>
                <Ads slot="1512251701" />
            </div>

            <div className='col-lg-8 latest-content order-3 order-lg-2 mb-5 ps-4'>

                <div className='d-none d-sm-block'>
                    <img className="shadowy article-thumb img-fluid mb-4" src={assets_url('coffee.webp')}
                        alt="Pokeland Legends Club donation"></img>
                </div>
                <div className='d-block d-sm-none'>
                    <img className="shadowy article-thumb img-fluid mb-4" src={assets_url('small-coffee.webp')}
                        alt="Pokeland Legends Club donation"></img>
                </div>

                <p>Thank you so much for supporting our website! Without you guys we wouldn’t be here today.</p>
                <p>We’ve accomplished so much thanks to all of you now and that gives us what we
                    need to keep this project alive with useful content for this community.</p>
                <p>Dany V1 and Vir7uaL,</p>
                <p>Pokeland Legends Club &reg; 2022</p>
                <b className='mb-3'>
                    <p>If you wish to support this project feel free to make a small donation.</p>
                </b>

                <h1><i className="fab fa-google"></i>oogle Adsense</h1>
                <hr></hr>
                <p>The ads shown in this website aren't intrusive and <b>100% safe</b>, that's why we ask all our users to
                    kindly turn off their Ad Blockers.</p>
                <p>We use Google Adsense on this site to cover our high costs. Google's use of the DoubleClick cookie
                    enables it and its partners to serve ads based on your visit to this site and/or other sites on the
                    Internet.</p>
            </div>

            <div className="col-lg-4 d-none d-lg-block order-lg-3">
                <Iframe url="https://www.buymeacoffee.com/widget/page/legendsclub?description=Support%20us.%20Buy%20us%20a%20coffee!&color=%235F7FFF"
                    width="100%"
                    height="100%"
                    id=""
                    className="buy-us-coffee"
                    display="block"
                    position="relative" />
            </div>
        </div>
    );
}
export default Donate;